import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  searchService: [
    'runtimeConstant',
    '$q',
    '$http',
    '$filter',
    'webApiSettings',
    'revService',
    'authService',
    '$window',
    function (
      runtimeConstant,
      $q,
      $http,
      $filter,
      webApiSettings,
      Revision,
      authService
    ) {
      'use strict';

      var searchServiceFactory = {};
      var loadRevisionsDeferred = null;

      var searchParams = {
        SearchTerm: '',
        SearchFields: [
          'code',
          'additionalFields',
          'title',
          'author',
          'documentType',
          'revisionDate',
          'description',
          'extension',
          'keywords',
          'folder',
          'content',
        ],
        StartIndex: 0,
        PageCount: 50,
        AllFolders: true,
        ThisFolder: false,
        SubFolders: false,
        selectedFolder: null,
        IsExactSearch: false,
      };

      var options = {
        folderFilter: '0',
        searchOnContent: true,
        isExactSearch: false,
        code: true,
        additionalFields: true,
        title: true,
        author: true,
        documentType: true,
        revisionDate: true,
        description: true,
        extension: true,
        keywords: true,
        folder: true,
        query: '',
      };

      function handleError(err, status) {
        if (status === 404 || status === -1) {
          var error = {
            error: $filter('translate')('SERVER OFFLINE'),
            error_description: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
          return error;
        }

        if (status !== 400) {
          var ex = {
            error: $filter('translate')('UNEXPECTED ERROR'),
            error_description:
              err !== null && err !== ''
                ? err.toString()
                : $filter('translate')('UNEXPECTED MESSAGE'),
          };
          return ex;
        }
        return err;
      }

      function isAutoLogin() {
        return authService.authentication.email === 'autologin';
      }

      function resetOptions() {
        options.folderFilter = '0';
        options.searchOnContent = true;
        options.code = true;
        options.additionalFields = true;
        options.title = true;
        options.author = true;
        options.documentType = true;
        options.revisionDate = true;
        options.description = true;
        options.extension = true;
        options.keywords = true;
        options.folder = true;
        options.query = '';
      }

      function setSearchConfigs() {
        if (isAutoLogin()) {
          options.searchOnContent =
            options.additionalFields =
            options.title =
            true;
          options.description = options.keywords = options.folder = true;
          options.code =
            options.author =
            options.extension =
            options.documentType =
            options.revisionDate =
            false;
          return;
        }

        var userPreferences = authService.user.userPreferences;

        if (
          userPreferences.SearchFields === null ||
          userPreferences.SearchFields === undefined
        ) {
          resetOptions();
          return;
        }

        var fields = userPreferences.SearchFields.split(';');

        options.searchOnContent = userPreferences.SearchOnContent;
        options.isExactSearch = userPreferences.IsExactSearch || false;
        options.code = fields.indexOf('code') > -1;
        options.additionalFields = fields.indexOf('additionalFields') > -1;
        options.title = fields.indexOf('title') > -1;
        options.author = fields.indexOf('author') > -1;
        options.documentType = fields.indexOf('documentType') > -1;
        options.revisionDate = fields.indexOf('revisionDate') > -1;
        options.description = fields.indexOf('description') > -1;
        options.extension = fields.indexOf('extension') > -1;
        options.keywords = fields.indexOf('keyWords') > -1;
        options.folder = fields.indexOf('folder') > -1;
      }

      var MAX_RECENT_SEARCHES = 5;
      var MAX_SUGGESTION_SOURCE = 20;
      var MAX_SUGGESTIONS = 5;

      function getSearchSuggestions(query) {
        var q = (query || '').trim().toLowerCase();
        if (q.length < 3) {
          return [];
        }

        if (!authService.user || !authService.user.userPreferences) {
          return [];
        }

        // Histórico completo no banco; pega as 20 mais recentes
        var terms = normalizeSearchTerms(
          authService.user.userPreferences.LastSearchTerms
        );
        var recent20 = terms.slice().reverse().slice(0, MAX_SUGGESTION_SOURCE);

        var matches = [];
        for (var i = 0; i < recent20.length; i++) {
          var term = recent20[i];
          if (term.toLowerCase().indexOf(q) !== -1) {
            matches.push(term);
            if (matches.length >= MAX_SUGGESTIONS) {
              break;
            }
          }
        }

        return matches;
      }

      function normalizeSearchTerms(raw) {
        if (raw === undefined || raw === null || raw === '') {
          return [];
        }
        return raw
          .split('§')
          .map(function (t) {
            return (t || '').trim();
          })
          .filter(function (t) {
            return t.length > 0;
          });
      }

      function persistUserPreferences(userPreferences) {
        if (authService.authentication.email === 'autologin') {
          return $q.resolve();
        }

        return $http
          .post(
            webApiSettings.apiServiceBaseUri + 'users/updatePreferences',
            userPreferences
          )
          .then(
            function () {
              authService.user.userPreferences = userPreferences;
            },
            function (err) {
              handleError(err.data, err.status);
            }
          );
      }

      function getRecentSearchTerms() {
        if (!authService.user || !authService.user.userPreferences) {
          return [];
        }

        var terms = normalizeSearchTerms(
          authService.user.userPreferences.LastSearchTerms
        );

        return terms.slice().reverse().slice(0, MAX_RECENT_SEARCHES);
      }

      function removeSearchTerm(term) {
        if (authService.authentication.email === 'autologin') {
          return $q.resolve([]);
        }

        var userPreferences = authService.user.userPreferences;
        if (!userPreferences) {
          return $q.resolve([]);
        }

        // Lista COMPLETA do banco
        var searchTerms = normalizeSearchTerms(userPreferences.LastSearchTerms);

        // Remove só o termo clicado
        var filtered = searchTerms.filter(function (t) {
          return t !== term;
        });

        userPreferences.LastSearchTerms = filtered.join('§');

        return persistUserPreferences(userPreferences).then(function () {
          return getRecentSearchTerms(); // só a tela limita em 5
        });
      }

      function clearSearchHistory() {
        if (authService.authentication.email === 'autologin') {
          return $q.resolve([]);
        }

        var userPreferences = authService.user.userPreferences;
        if (!userPreferences) {
          return $q.resolve([]);
        }

        userPreferences.LastSearchTerms = '';

        return persistUserPreferences(userPreferences).then(function () {
          return [];
        });
      }

      function updateSerchPreferences() {
        if (authService.authentication.email === 'autologin') return;

        var userPreferences = authService.user.userPreferences;

        var contentIndex = searchParams.SearchFields.indexOf('content');
        var items = searchParams.SearchFields.slice();

        if (contentIndex > -1) items.splice(contentIndex, 1);

        userPreferences.SearchFields = items.join(';');
        userPreferences.SearchOnContent = contentIndex > -1;
        userPreferences.IsExactSearch = searchParams.IsExactSearch;

        var term = (searchParams.SearchTerm || '').trim();
        if (term) {
          var searchTerms = normalizeSearchTerms(userPreferences.LastSearchTerms);

          // Se já existe, remove e recoloca como mais recente
          searchTerms = searchTerms.filter(function (t) {
            return t !== term;
          });

          searchTerms.push(term);

          userPreferences.LastSearchTerms = searchTerms.join('§');
        }

        persistUserPreferences(userPreferences);
      }

      function translateSearchField(searchField) {
        let findOn = $filter('translate')('FIND ON');
        let findAt = $filter('translate')('FIND AT');
        let findIn = $filter('translate')('FIND IN');
        let findAtThe = $filter('translate')('FIND AT THE');
        let title = $filter('translate')('TITLE');
        let additionalFields = $filter('translate')('ADDITIONAL FIELDS');
        let description = $filter('translate')('DESCRIPTION');
        let author = $filter('translate')('AUTHOR');
        let documentType = $filter('translate')('DOCUMENT TYPE');
        let revisionDate = $filter('translate')('REVISION DATE');
        let keywords = $filter('translate')('KEYWORDS');
        let folder = $filter('translate')('FOLDER');
        let code = $filter('translate')('CODE');
        let extension = $filter('translate')('EXTENSION');
        let content = $filter('translate')('CONTENT');
        let strFormat =
          // eslint-disable-next-line quotes
          "<div style=\'color: #aeaeae;display: inline-block;\'><small>{0} {1}:</small></div>";
        let lowerCaseSearchField = searchField.toLowerCase();

        switch (lowerCaseSearchField) {
          case 'title':
            strFormat = strFormat.replace('{0}', findOn);
            strFormat = strFormat.replace('{1}', title);
            break;
          case 'additionalfields':
            strFormat = strFormat.replace('{0}', findAt);
            strFormat = strFormat.replace('{1}', additionalFields);
            break;
          case 'description':
            strFormat = strFormat.replace('{0}', findIn);
            strFormat = strFormat.replace('{1}', description);
            break;
          case 'author':
            strFormat = strFormat.replace('{0}', findOn);
            strFormat = strFormat.replace('{1}', author);
            break;
          case 'documenttype':
            strFormat = strFormat.replace('{0}', findOn);
            strFormat = strFormat.replace('{1}', documentType);
            break;
          case 'revisiondate':
            strFormat = strFormat.replace('{0}', findIn);
            strFormat = strFormat.replace('{1}', revisionDate);
            break;
          case 'keywords':
            strFormat = strFormat.replace('{0}', findAtThe);
            strFormat = strFormat.replace('{1}', keywords);
            break;
          case 'folder':
            strFormat = strFormat.replace('{0}', findIn);
            strFormat = strFormat.replace('{1}', folder);
            break;
          case 'code':
            strFormat = strFormat.replace('{0}', findOn);
            strFormat = strFormat.replace('{1}', code);
            break;
          case 'extension':
            strFormat = strFormat.replace('{0}', findIn);
            strFormat = strFormat.replace('{1}', extension);
            break;
          case 'content':
            strFormat = strFormat.replace('{0}', findOn);
            strFormat = strFormat.replace('{1}', content);
            break;
        }

        return strFormat;
      }

      function formatOcurrence(ocurrence) {
        let value =
          '<div class="flat-breaks" style="display: inline;">' +
          ocurrence +
          '</div><br>';
        return value;
      }

      function getHighlightFieldFormatted(searchField, ocurrence) {
        let value =
          translateSearchField(searchField) + ' ' + formatOcurrence(ocurrence);
        return value;
      }

      function setHighlightFields(data, resultIndex, searchField, ocurrence) {
        switch (searchField) {
          case 'documentType':
            if (isAutoLogin()) {
              data[resultIndex].HighlightFields['all'] += ocurrence + ' ... ';
            } else {
              data[resultIndex].DocumentType.Name = ocurrence;
            }
            break;
          case 'author':
            if (isAutoLogin()) {
              data[resultIndex].HighlightFields['all'] += ocurrence + ' ... ';
            } else {
              data[resultIndex].Author.Name = ocurrence;
            }
            break;
          case 'code':
            if (isAutoLogin()) {
              data[resultIndex].HighlightFields['all'] += ocurrence + ' ... ';
            } else {
              data[resultIndex].Code = ocurrence;
            }
            break;
          default:
            data[resultIndex].HighlightFields['all'] +=
              getHighlightFieldFormatted(searchField, ocurrence);
            break;
        }
      }

      function trashCanSearch(
        searchTerm,
        searchFields,
        place,
        currentPage,
        pageSize
      ) {
        if (loadRevisionsDeferred !== null) {
          loadRevisionsDeferred.resolve({
            result: [],
            count: 0,
          });
          loadRevisionsDeferred = null;
        }

        var deferred = $q.defer();
        loadRevisionsDeferred = deferred;

        searchParams.SearchTerm = searchTerm;
        searchParams.StartIndex = (1 - 1) * pageSize;
        searchParams.PageCount = 50;
        searchParams.SearchFields = searchFields;
        searchParams.AllFolders = place === 0;

        $http
          .post(
            webApiSettings.apiServiceBaseUri + 'revisions/search/TrashCan/',
            searchParams,
            {
              timeout: loadRevisionsDeferred.promise,
            }
          )
          .then(
            function (res) {
              var data = res.data.Result;
              for (var i = data.length - 1; i >= 0; i--) {
                for (var j = 0; j < searchParams.SearchFields.length; j++) {
                  var searchField = searchParams.SearchFields[j];
                  if (data[i].HighlightFields[searchField] !== null) {
                    if (data[i].HighlightFields['all'] === undefined)
                      data[i].HighlightFields['all'] = '';

                    var ocurrence =
                      data[i].HighlightFields[searchParams.SearchFields[j]];
                    if (searchField === 'title') {
                      data[i].TitleOriginal = data[i].Title;
                      data[i].Title = ocurrence.toString();
                    } else {
                      if (searchField === 'description' && isAutoLogin()) {
                        data[i].DescriptionOriginal = data[i].Description;
                        data[i].Description = ocurrence.toString();
                      } else {
                        setHighlightFields(data, i, searchField, ocurrence);
                      }
                    }
                  }
                }
              }

              var result = [];
              var data2 = resolveReferences(data);

              if (data.length > 0) {
                data2.forEach(function (d) {
                  var rev = new Revision(d, null);
                  rev.titleOriginal = d.TitleOriginal;
                  rev.descriptionOriginal = d.DescriptionOriginal;
                  result.push(rev);
                });
              }

              deferred.resolve(result);
              updateSerchPreferences();
              loadRevisionsDeferred = null;
            },
            function (err) {
              var error = handleError(err.data, err.status);

              deferred.reject(error);
              loadRevisionsDeferred = null;
            }
          );

        return deferred.promise;
      }

      function getSearchFieldsOrdered(searchFields) {
        // mapa de campos
        const fieldMap = {
          title: 'title',
          additionalFields: 'additionalFields',
          description: 'description',
          author: 'author',
          documentType: 'documentType',
          revisionDate: 'revisionDate',
          keyWords: 'keyWords',
          folder: 'folder',
          code: 'code',
          extension: 'extension',
          content: 'content',
        };

        // array original
        let split = searchFields.split(';');

        // array ordenado
        let ordered = [];

        // popula o array ordenado a partir do mapa de campos
        for (let field in fieldMap) {
          if (split.includes(field)) {
            ordered.push(field);
          }
        }

        return ordered;
      }

      function execute(searchTerm, searchFields, isExactSearch, place, page, pageSize) {
        if (loadRevisionsDeferred !== null) {
          loadRevisionsDeferred.resolve({
            result: [],
            count: 0,
          });
          loadRevisionsDeferred = null;
        }

        var deferred = $q.defer();
        loadRevisionsDeferred = deferred;

        searchParams.SearchTerm = searchTerm;
        searchParams.StartIndex = (page - 1) * pageSize;
        searchParams.PageCount = pageSize;
        searchParams.SearchFields = getSearchFieldsOrdered(searchFields);
        searchParams.AllFolders = place === 0;
        searchParams.ThisFolder = place === 1;
        searchParams.SubFolders = place === 2;
        searchParams.IsExactSearch = isExactSearch;

        $http
          .post(
            webApiSettings.apiServiceBaseUri + 'revisions/search/virtual2',
            searchParams,
            {
              timeout: loadRevisionsDeferred.promise,
            }
          )
          .then(
            function (res) {
              var data = res.data.Result;

              for (var i = data.length - 1; i >= 0; i--) {
                for (var j = 0; j < searchParams.SearchFields.length; j++) {
                  var searchField = searchParams.SearchFields[j];
                  if (data[i].HighlightFields[searchField] !== undefined) {
                    if (data[i].HighlightFields['all'] === undefined)
                      data[i].HighlightFields['all'] = '';

                    var ocurrence =
                      data[i].HighlightFields[searchParams.SearchFields[j]];

                    if (searchField === 'title') {
                      data[i].TitleOriginal = data[i].Title;
                      data[i].Title = ocurrence.toString();
                    } else {
                      if (searchField === 'description' && isAutoLogin()) {
                        data[i].DescriptionOriginal = data[i].Description;
                        data[i].Description = ocurrence.toString();
                      } else {
                        setHighlightFields(data, i, searchField, ocurrence);
                      }
                    }
                  }
                }
              }

              var result = [];
              var data2 = resolveReferences(data);

              if (data.length > 0) {
                data2.forEach(function (d) {
                  var rev = new Revision(d, null);
                  rev.titleOriginal = d.TitleOriginal;
                  rev.descriptionOriginal = d.DescriptionOriginal;
                  result.push(rev);
                });
              }

              deferred.resolve({
                count: res.data.Count,
                result: result,
              });

              updateSerchPreferences();
              loadRevisionsDeferred = null;
            },
            function (err) {
              var error = handleError(err.data, err.status);

              deferred.reject(error);
              loadRevisionsDeferred = null;
            }
          );

        return deferred.promise;
      }

      function cancel() {
        if (loadRevisionsDeferred !== null) {
          loadRevisionsDeferred.resolve({
            result: [],
            count: 0,
          });
          loadRevisionsDeferred = null;
        }
      }

      function run() {
        try {
          searchServiceFactory.options = options;
          searchServiceFactory.searchParams = searchParams;

          searchServiceFactory.resetOptions = logWrapper(
            resetOptions,
            runtimeConstant.isDebugServicesInternals
          );
          searchServiceFactory.execute = logWrapper(
            execute,
            runtimeConstant.isDebugServicesInternals
          );
          searchServiceFactory.trashCanSearch = logWrapper(
            trashCanSearch,
            runtimeConstant.isDebugServicesInternals
          );
          searchServiceFactory.cancel = logWrapper(
            cancel,
            runtimeConstant.isDebugServicesInternals
          );
          searchServiceFactory.setSearchConfigs = logWrapper(
            setSearchConfigs,
            runtimeConstant.isDebugServicesInternals
          );
          searchServiceFactory.getRecentSearchTerms = logWrapper(
            getRecentSearchTerms,
            runtimeConstant.isDebugServicesInternals
          );
          searchServiceFactory.removeSearchTerm = logWrapper(
            removeSearchTerm,
            runtimeConstant.isDebugServicesInternals
          );
          searchServiceFactory.clearSearchHistory = logWrapper(
            clearSearchHistory,
            runtimeConstant.isDebugServicesInternals
          );
          searchServiceFactory.getSearchSuggestions = logWrapper(
            getSearchSuggestions,
            runtimeConstant.isDebugServicesInternals
          );

          return searchServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
